import React, { Component } from 'react';
import { Link as LinkFeather } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { AddButton } from '../../components/AddButton';
import { Loader } from '../../components/Loader';
import * as actions from "../../redux/clinics";
import AuthenticateChildren from '../../AuthenticateChildren';
import { roles } from '../../constants';

class Clinics extends Component {
    componentDidMount() {
        this.props.fetchclinics(this.props);
    }

    renderTable() {
        return !this.props.clinics ? null : <div>
            <AuthenticateChildren roles={[ roles.Admin, roles.Owner ]}>
                <AddButton to={`/clinics/new`} />
            </AuthenticateChildren>
            <table className='table table-striped'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.clinics.map(clinic =>
                        <tr key={clinic.id}>
                            <td>{clinic.name}</td>
                            <td><Link to={`/clinics/${clinic.id}`}><LinkFeather>Edit</LinkFeather></Link></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    render() {
        return (
            <div>
                <h1>Clinics</h1>
                <Loader loading={this.props.loading}>
                    {this.renderTable()}
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ clinics }) => ({
    clinics: clinics.clinics,
    loading: clinics.loading,
    error: clinics.error
});

export default connect(mapStateToProps, actions)(withRouter(Clinics));


// WEBPACK FOOTER //
// ./src/pages/Clinics/Clinics.js